import Checkbox from './Checkbox'
export default  Checkbox



// WEBPACK FOOTER //
// ./components/Checkbox/index.js